import React from 'react';

import Field, { hasDataInFields } from '../../Field';
import BlockHomeStep from '../../BlockBuilder/BlockHomeStep/BlockHomeStep';

import SectionContainer from '../SectionContainer';
import css from './SectionHomeSteps.module.css';

/**
 * Renders the section title, parsing **bold** markers as green-accent spans.
 * Example: "3 pasos para **vender**" → "vender" in accent green.
 */
const AccentTitle = ({ data }) => {
  if (!data?.content) return null;
  const parts = data.content.split(/\*\*(.*?)\*\*/g);
  return (
    <h2 className={css.title}>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <span key={i} className={css.titleAccent}>{part}</span>
        ) : (
          part
        )
      )}
    </h2>
  );
};

const SectionHomeSteps = props => {
  const {
    sectionId,
    className,
    title,
    description,
    appearance,
    callToAction,
    blocks = [],
    options,
  } = props;

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description], fieldOptions);
  const hasBlocks = blocks?.length > 0;

  return (
    <SectionContainer
      id={sectionId}
      rootClassName={css.root}
      className={className}
      appearance={appearance}
      options={fieldOptions}
    >
      <div className={css.container}>
        {hasHeaderFields ? (
          <div className={css.headerRow}>
            <AccentTitle data={title} />
            {description?.content ? (
              <Field data={description} className={css.descriptionField} options={fieldOptions} />
            ) : null}
          </div>
        ) : null}

        {hasBlocks ? (
          <div className={css.stepsGrid}>
            {blocks.map((block, index) => (
              <BlockHomeStep
                key={block.blockId || index}
                blockId={block.blockId}
                blockName={block.blockName}
                blockType={block.blockType}
                title={block.title}
                text={block.text}
                callToAction={block.callToAction}
                media={block.media}
                alignment={block.alignment}
                stepNumber={index + 1}
                options={options}
                responsiveImageSizes="(max-width: 767px) 100vw, 400px"
              />
            ))}
          </div>
        ) : null}

        {callToAction?.content ? (
          <div className={css.ctaRow}>
            <Field data={callToAction} className={css.ctaButton} options={fieldOptions} />
          </div>
        ) : null}
      </div>
    </SectionContainer>
  );
};

export default SectionHomeSteps;
